module.exports = __webpack_public_path__ + "img/top-howto3.dce9c608.png";